import React, { useEffect } from "react";
import View from "../features/candidate/candidate-view/View.js";

import { useCandidate } from "hooks/useCandidate.js";
import { CircularProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useNotifications from "hooks/useNotifications.js";

export const CandidateView = () => {
    const { id } = useParams();
    const { setCandidateToState, isLoading, error } = useCandidate();
    const currentCandidate = useSelector((state) => state.currentCandidate);
    const { renderErrorNotification } = useNotifications();
    const navigate = useNavigate();

    useEffect(() => {
        setCandidateToState(id);
        if (error) {
            renderErrorNotification(
                "You are not authorized to access this resource",
            );
            navigate("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, error]);

    return !isLoading && currentCandidate !== null ? (
        <View candidateId={id} />
    ) : (
        <CircularProgress />
    );
};

export default CandidateView;
